import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import translationENG from "./locales/en/translation.json"
import translationTR from "./locales/tr/translation.json"
import translationDE from "./locales/de/translation.json"
import translationES from "./locales/es/translation.json"
import translationFR from "./locales/fr/translation.json"
import translationAR from "./locales/ar/translation.json"
import translationRU from "./locales/ru/translation.json"
import translationIT from "./locales/it/translation.json"

const DEFAULT_LANGUAGE = "tr"

const resources = {
  en: {
    translation: translationENG,
  },
  tr: {
    translation: translationTR,
  },
  de: {
    translation: translationDE,
  },
  es: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
  ru: {
    translation: translationRU,
  },
  it: {
    translation: translationIT,
  },
}

try {
  localStorage.setItem("I18N_LANGUAGE", DEFAULT_LANGUAGE)
} catch (e) {
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: DEFAULT_LANGUAGE,
    
    fallbackLng: "en",

    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "I18N_LANGUAGE",
      caches: ["localStorage"],
    },

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added removed",
    },
  })

// Keep document direction in sync with language
i18n.on("languageChanged", lng => {
  try {
    if (typeof document !== "undefined") {
      const isRtl = lng === "ar"
      document.documentElement.setAttribute("dir", isRtl ? "rtl" : "ltr")
      document.documentElement.setAttribute("lang", lng)
    }
  } catch (e) {
  }
})

export default i18n